import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(3.000000, 3.000000)">
      <g transform="translate(16.00000, 13.000000)">
        <path
          d="M 0 54.56 L 18.72 0 L 27.04 0 L 45.76 54.56 L 38.8 54.56 L 34 40 L 11.84 40 L 6.96 54.56 L 0 54.56 Z M 13.92 33.6 L 31.84 33.6 L 23.04 6.4 L 22.8 6.4 L 13.92 33.6 Z"
          fill="currentColor"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <polygon
        id="Shape"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="39 0 0 22 0 67 39 90 78 68 78 23"
      />
    </g>
  </svg>
);

export default IconLogo;
